import React from 'react'
import { Settings2 } from '@mailstep/design-system/ui/Elements/Icon/icons/Settings2'
import { Puzzle1 } from '@mailstep/design-system/ui/Elements/Icon/icons/Puzzle1'
import { Inventory2 } from '@mailstep/design-system/ui/Elements/Icon/icons/Inventory2'
import { Logout1 } from '@mailstep/design-system/ui/Elements/Icon/icons/Logout1'
import { Trans } from '@lingui/react'
import { Dispatch } from 'redux'
import { actions as adminActions } from '@store/admin'
import { actions as userActions } from '@store/user'
import { Props as HeadingProps } from '@components/blocks/Heading'
import routes from '@pages/index'

export const createUserMenuItems = (
  dispatch: Dispatch,
  handleSettingsNavigation: () => void,
  isAdmin: boolean,
): HeadingProps['userMenuItems'] => {
  return [
    {
      title: <Trans id="heading.userMenu.settings" message="Settings" />,
      link: isAdmin ? routes.adminEditUser.route.toUrl() : routes.userEditUser.route.toUrl(),
      icon: <Settings2 width="18px" height="18px" stroke="#374151" />,
      onClick: handleSettingsNavigation,
    },
    ...(isAdmin
      ? [
          {
            title: <Trans id="heading.userMenu.exchangeRates" message="Exchange Rates" />,
            link: '#',
            icon: <Puzzle1 width="18px" height="18px" />,
            onClick: (): void => {
              dispatch(uiActions.openQuickAccessDialog('exchangeRates'))
            },
          },
          {
            title: <Trans id="heading.userMenu.logs" message="Logs" />,
            link: routes.sharedAudits.route.toUrl(),
            icon: <Inventory2 width="18px" height="18px" />,
            autoClose: true,
          },
        ]
      : []),
    {
      title: <Trans id="heading.userMenu.logout" message="Logout" />,
      onClick: (): void => {
        dispatch(isAdmin ? adminActions.logout() : userActions.logout())
      },
      link: '#',
      hasSeparator: true,
      icon: <Logout1 width="18px" height="18px" />,
    },
  ]
}
